<template>
  <div class="sidebar__link-wrapper">
    <router-link to="/salary-documents" class="sidebar__link">
      <i class="fa-solid fa-file-invoice-dollar"></i>
      <p>{{ $t("Sidebar.salary-documents") }}</p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "hrSidebar",
};
</script>

<style></style>
